import React from "react";
import Filter from "./Filter";
import DataTable from "../Reusable/Datatable";
import APIS from "../../constant/Endpoint";
import NACell from "../Reusable/Datatable/NACell";
import { ColumnDef } from "@tanstack/react-table";
import { useForm, useWatch } from "react-hook-form";
import { useSearchParams } from "react-router-dom";
import moment from "moment";

const StockMovement = () => {
  const [searchParams, setSearchParams] = useSearchParams();
  const startOfMonth = moment().startOf("month").format("YYYY-MM-DD");
  const endOfMonth = moment().endOf("month").format("YYYY-MM-DD");
  const {
    control,
    register,
    getValues,
    setValue,
    clearErrors,
    formState: { errors },
  } = useForm<any>({
    defaultValues: {
      account: searchParams.get("account") || "",
      user: searchParams.get("user") || "",
      created: searchParams.get("created") || "",
      created__range: `${startOfMonth},${endOfMonth}`,
    },
  });
  const formValues = useWatch({ control });
  const columns: ColumnDef<any, any>[] = [
    {
      accessorKey: "name",
      header: "Product Name",
      cell: NACell,
    },
    {
      accessorKey: "unit.name",
      header: "Unit",
      cell: NACell,
    },
    {
      accessorKey: "opening_quantity",
      header: "Opening Quantity",
      cell: NACell,
    },
    {
      accessorKey: "received",
      header: "Received",
      cell: NACell,
    },
    {
      accessorKey: "issued",
      header: "Issued",
      cell: NACell,
    },
    {
      accessorKey: "opening_balance",
      header: "Closing Quantity",
      cell: NACell,
    },
  ];
  return (
    <>
      <Filter
        register={register}
        errors={errors}
        setValue={setValue}
        getValues={getValues}
        clearErrors={clearErrors}
      />
      <DataTable
        columns={columns}
        queryKey={"inventory-info"}
        url={`${APIS.PRODUCT}items/`}
        params={{}}
        customSearch={true}
        tableName="inventory-info"
      />
    </>
  );
};

export default StockMovement;

